





























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import BackofficeTempoCirurgicoPorProcedimentoStore from '@/components/Backoffice/Store/BackofficeTempoCirurgicoPorProcedimentoStore'
import { getModule } from 'vuex-module-decorators'
import { onlyNumber } from '@/utils/common'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalSuporteTempoCirurgicoPorProcedimento extends Vue {
  @Prop({ required: true, default: 'hospital' }) procedimentoType: 'medico' | 'hospital'
  loadSaveOrUpdateTempoCirurgicoPorProcedimento: boolean = false

  get getBackofficeTempoCirurgicoPorProcedimentoStore() {
    return getModule(BackofficeTempoCirurgicoPorProcedimentoStore, this.$store)
  }

  get loadingSaveOrUpdateTempoCirurgicoPorProcedimento() {
    return this.loadSaveOrUpdateTempoCirurgicoPorProcedimento
  }

  set loadingSaveOrUpdateTempoCirurgicoPorProcedimento(value: boolean) {
    this.loadSaveOrUpdateTempoCirurgicoPorProcedimento = value
  }

  get showModalTempoCirurgicoPorProcedimento() {
    return this.getBackofficeTempoCirurgicoPorProcedimentoStore.modal.tempoCirurgicoPorProcedimento
  }

  set showModalTempoCirurgicoPorProcedimento(value: boolean) {
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.setModal({ name: 'tempoCirurgicoPorProcedimento', value })
  }

  get procedimentos() {
    return this.getBackofficeTempoCirurgicoPorProcedimentoStore.procedimentos
  }

  get medicos() {
    return this.getBackofficeTempoCirurgicoPorProcedimentoStore.medicos
  }

  get tempoCirurgicoPorProcedimento() {
    return this.getBackofficeTempoCirurgicoPorProcedimentoStore.tempoCirurgicoPorProcedimento
  }

  $refs!: {
    formTempoCirurgicoPorProcedimento: any
  }

  formTempoCirurgicoPorProcedimentoRules: any = {
    valid: true,
    procedimentoId: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  onlyNumberUtil(v: any) {
    return onlyNumber(v)
  }

  async saveOrUpdateTempoCirurgicoPorProcedimento() {
    this.loadingSaveOrUpdateTempoCirurgicoPorProcedimento = true

    if (this.$refs.formTempoCirurgicoPorProcedimento.validate()) {
      const { mode } = this.getBackofficeTempoCirurgicoPorProcedimentoStore

      const response = await this.getBackofficeTempoCirurgicoPorProcedimentoStore.upsertProcedimentosTempoCirurgico()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Tempo cirúrgico ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getBackofficeTempoCirurgicoPorProcedimentoStore.getTempoCirurgicoPorProcedimentoPagedSearch(this.getBackofficeTempoCirurgicoPorProcedimentoStore.paginationTempoCirurgicoPorProcedimento)
        await this.getBackofficeTempoCirurgicoPorProcedimentoStore.getTempoCirurgicoPorProcedimentoMedicoPagedSearch(this.getBackofficeTempoCirurgicoPorProcedimentoStore.paginationTempoCirurgicoPorProcedimentoMedico)
        this.showModalTempoCirurgicoPorProcedimento = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o tempo cirúrgico ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateTempoCirurgicoPorProcedimento = false
  }

  @Watch('showModalTempoCirurgicoPorProcedimento')
  onChangeshowModalTempoCirurgicoPorProcedimento(value: boolean) {
    if (!value) {
      this.getBackofficeTempoCirurgicoPorProcedimentoStore.clearTempoCirurgicoPorProcedimento()
      this.getBackofficeTempoCirurgicoPorProcedimentoStore.setMode({ mode: 'CREATE' })
      this.$refs.formTempoCirurgicoPorProcedimento.resetValidation()
    }
  }
}
